function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "2htha",
  d: "M127.999 847.945a2.936 2.936 0 0 1-2.935-2.94 2.936 2.936 0 1 1 5.87 0 2.938 2.938 0 0 1-2.935 2.94zm7.687-4.303l-2-.194a5.766 5.766 0 0 0-.569-1.375l1.276-1.549a.354.354 0 0 0-.02-.467l-1.429-1.43a.357.357 0 0 0-.468-.023l-1.55 1.276a5.933 5.933 0 0 0-1.377-.569l-.192-1.996a.357.357 0 0 0-.348-.315h-2.022a.356.356 0 0 0-.345.315l-.192 1.996a6.043 6.043 0 0 0-1.378.568l-1.547-1.273a.36.36 0 0 0-.469.023l-1.429 1.43a.355.355 0 0 0-.022.468l1.275 1.546a5.81 5.81 0 0 0-.57 1.378l-1.994.193a.355.355 0 0 0-.316.346v2.02c0 .175.142.33.316.346l1.995.194c.133.485.322.95.57 1.377l-1.274 1.546a.357.357 0 0 0 .02.469l1.43 1.43a.36.36 0 0 0 .47.021l1.544-1.274c.43.246.89.436 1.38.568l.19 1.997a.36.36 0 0 0 .35.316h2.02c.173 0 .33-.144.346-.316l.193-1.997a5.939 5.939 0 0 0 1.377-.57l1.548 1.276c.132.11.344.1.468-.024l1.428-1.43a.356.356 0 0 0 .02-.468l-1.273-1.546c.244-.428.435-.892.567-1.377l2-.194a.357.357 0 0 0 .315-.346v-2.018a.355.355 0 0 0-.314-.348z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-120 -837)"
}, React.createElement("use", {
  fill: "#2e333b",
  xlinkHref: "#2htha"
})));

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings.94a1279d.svg";
export { ForwardRef as ReactComponent };